const faqItems = document.querySelectorAll('.faq-item')

faqItems.forEach(item => {
    const question = item.querySelector('.faq-question')
    question.addEventListener('click', () => {
        item.classList.toggle('active')
    })
})

document.querySelectorAll('.lower-bottom-content__list .metafield-rich_text_field h4').forEach(item => {
    const wrapperDiv = document.createElement('div'); 
    const clonedItem = item.cloneNode(true); // Clone the h4
    const nextP = item.nextElementSibling; // Get the next sibling (p tag)

    wrapperDiv.appendChild(clonedItem); // Append the cloned h4 to the div

    if (nextP && nextP.tagName === 'P') { // Check if the next sibling is a p tag
        const clonedP = nextP.cloneNode(true); // Clone the p tag
        wrapperDiv.appendChild(clonedP); // Append the cloned p to the div
    }

    item.parentNode.replaceChild(wrapperDiv, item); // Replace h4 with the div
    if (nextP && nextP.tagName === 'P') {
        nextP.parentNode.removeChild(nextP); // Remove the original p tag
    }
});